import { HiOutlineCalendar } from 'react-icons/hi';
import { IDateInput } from '../../interfaces/components/input.interface';

const DateInput: React.FC<IDateInput> = ({
  value,
  setValue,
  placeholder = undefined,
  sideComponents,
  classname = undefined,
  error = false,
  isObject = false,
  name = '',
  min = undefined,
  max = undefined,
  disabled = false,
  onBlur,
  showIcon = true,
}) => {
  console.log('date changed: ' + value);
  return (
    <main
      className={`${classname} px-3 border   ${
        error
          ? 'border-red-500 focus-within:border-gray-300'
          : 'border-[#e2e2e2] focus-within:border-sky-500'
      } rounded-lg flex items-center justify-start gap-3 relative max-w-full`}
    >
      {disabled && (
        <div className="absolute z-20 w-full h-full top-0 left-0 rounded-lg bg-gray-300 opacity-30"></div>
      )}
      {showIcon && (
        <p className="bg-[#2691BD1A] text-primary text-lg p-1 rounded-md">
          <HiOutlineCalendar />
        </p>
      )}
      <div className="relative flex-1 flex">
        <input
          type={'month'}
          name={name}
          onChange={(e) =>
            isObject
              ? setValue(e.target.name, e.target.value)
              : setValue(e.target.value)
          }
          className={`text-gray-600 bg-transparent focus:outline-none py-3 h-full flex-1 z-10 relative ${
            value
              ? 'before:hidden'
              : `before:content-[attr(placeholder)] before:bg-white before:absolute before:top-1/2 before:transform before:-translate-y-1/2
               before:left-0 before:z-20 before:w-[80%] before:text-[#C4C4C4] before:font-thin focus:before:hidden active:before:hidden`
          } `}
          value={value ? value.slice(0, 7) : ''}
          placeholder={placeholder || 'Ngày nhận'}
          min={min !== undefined ? min : ''}
          max={max !== undefined ? max : ''}
          onBlur={onBlur}
        />
      </div>
      {sideComponents}
    </main>
  );
};

export default DateInput;
